import Typography from '@mui/material/Typography';

type Props = {
  text: string;
  color?: string;
  fontSize?: string;
};

const Header = ({ text, color, fontSize }: Props) => (
  <Typography
    data-testid="base-header"
    variant="h2"
    sx={{
      color: color ?? 'inherit',
      fontSize: fontSize ?? '20px',
      fontWeight: 500,
      lineHeight: '25px'
    }}
  >
    {text}
  </Typography>
);

export default Header;
